var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"de-text-percent"},[_c('span',{staticClass:"arrow",style:(_vm.selfArrowStyle)}),_c('span',{staticClass:"percent",style:(_vm.selfPercentStyle)},[_vm._v(_vm._s(Math.abs(_vm.percent))+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }